/**
 * WEB-2351, возврат 1 — подпись отказа «число вне границ автора» на языке
 * ВОРОНКИ. Словарь живёт вне первого экрана: его тянет только проверка границ
 * (`components/quiz-runtime/numberBounds.ts`) в едином ленивом куске плеера
 * (`player/playerKit.ts`) — вес первого экрана держит храповик
 * (`publicEntry.build.web1988`). Раньше строка лежала в ядре
 * `publicQuizStrings.ts` (ru/en) и в 27 пакетах языков — ядро ехало каждому
 * покупателю.
 *
 * Полноту по языкам держит тип: `Record<SupportedPublicQuizLocale, …>` —
 * новый язык набора без строки здесь не соберётся. «Не английский на каждом
 * языке» — сторож WEB-967 (`player-strings-locale.web967.test.ts`, реестр
 * `PLAYER_DICTIONARIES`). Выбор языка — та же дверь, что у надписей плеера
 * (`resolvePublicQuizLocale`). `{range}` — «18–99», «≥ 18» или «≤ 99».
 */
import {
  resolvePublicQuizLocale,
  type SupportedPublicQuizLocale,
} from './publicQuizStrings';

const NUMBER_OUT_OF_RANGE: Readonly<Record<SupportedPublicQuizLocale, string>> =
  {
    en: 'Allowed values: {range}',
    ru: 'Допустимые значения: {range}',
    es: 'Valores permitidos: {range}',
    de: 'Zulässige Werte: {range}',
    fr: 'Valeurs autorisées : {range}',
    it: 'Valori consentiti: {range}',
    pt: 'Valores permitidos: {range}',
    'pt-BR': 'Valores permitidos: {range}',
    zh: '允许的数值：{range}',
    'zh-CN': '允许的数值：{range}',
    'zh-TW': '允許的數值：{range}',
    ja: '入力できる値: {range}',
    ko: '허용되는 값: {range}',
    ar: 'القيم المسموح بها: {range}',
    he: 'ערכים מותרים: {range}',
    hi: 'अनुमत मान: {range}',
    tr: 'İzin verilen değerler: {range}',
    pl: 'Dozwolone wartości: {range}',
    nl: 'Toegestane waarden: {range}',
    sv: 'Tillåtna värden: {range}',
    da: 'Tilladte værdier: {range}',
    no: 'Tillatte verdier: {range}',
    fi: 'Sallitut arvot: {range}',
    cs: 'Povolené hodnoty: {range}',
    el: 'Επιτρεπόμενες τιμές: {range}',
    uk: 'Допустимі значення: {range}',
    ro: 'Valori permise: {range}',
    hu: 'Megengedett értékek: {range}',
    th: 'ค่าที่อนุญาต: {range}',
    vi: 'Giá trị cho phép: {range}',
    id: 'Nilai yang diizinkan: {range}',
  };

export interface NumberBoundsStrings {
  numberOutOfRangeWarning: string;
}

/** Дверь словаря: язык воронки → подпись (неизвестный язык — английский). */
export function getNumberBoundsStrings(
  language?: string | null,
): NumberBoundsStrings {
  return {
    numberOutOfRangeWarning:
      NUMBER_OUT_OF_RANGE[resolvePublicQuizLocale(language)],
  };
}
